import ServiceTabs from "./servicetabs";

export default function ReletedServices({ id, toggleModal }) {
  return (
    <section
      id={id}
      className="relative block w-full lg:py-[70px] py-[50px]"
    >
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">        
        <div className="text-center lg:pb-[50px] pb-6">
          <h2
            className="lg:text-[50px] text-[39px] lg:leading-[76px] leading-none font-bold text-black text-center mb-4 tracking-tight"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            Our Tech Stack
          </h2>
          <p
            className="text-base font-normal leading-6 text-black"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            Empowering innovation with cutting-edge tools and technologies to{" "}
            <br className="hidden lg:block" /> drive your success.
          </p>
        </div>
        <div>
          <ServiceTabs toggleModal={toggleModal} />
        </div>
      </div>
    </section>
  );
}
